import React from 'react';

export const MyProfileSignatureCard = ({
    signatureEditorRef,
    onEditorInput,
    onEditorCommand,
    onSave,
    isSavingSignature,
}) => {
    return (
        <div className="card card__no-border profile-card-surface">
            <div className="card-body p-4">
                <h6 className="fw-semibold mb-3">Firma de tickets</h6>
                <p className="text-muted fs-12 mb-2">Esta firma se agregará automáticamente al final de tus respuestas en tickets.</p>

                <div className="profile-signature-toolbar mb-2">
                    <button type="button" className="btn btn-light btn-sm" onClick={() => onEditorCommand('bold')}>
                        <i className="bi bi-type-bold" aria-hidden="true" />
                    </button>
                    <button type="button" className="btn btn-light btn-sm" onClick={() => onEditorCommand('italic')}>
                        <i className="bi bi-type-italic" aria-hidden="true" />
                    </button>
                    <button type="button" className="btn btn-light btn-sm" onClick={() => onEditorCommand('insertUnorderedList')}>
                        <i className="bi bi-list-ul" aria-hidden="true" />
                    </button>
                </div>

                <div
                    ref={signatureEditorRef}
                    className="form-control profile-signature-editor"
                    contentEditable
                    suppressContentEditableWarning
                    onInput={onEditorInput}
                    style={{ minHeight: '150px' }}
                />

                <div className="d-flex justify-content-end mt-3">
                    <button type="button" className="btn btn-primary" onClick={onSave} disabled={isSavingSignature}>
                        {isSavingSignature ? 'Guardando...' : 'Guardar firma'}
                    </button>
                </div>
            </div>
        </div>
    );
};
